module.exports = __webpack_public_path__ + "fonts/318fbac.woff";